export const customerCategories = ["loyaltyUser", "pos", "payer", "distributor", "chain"] as const;
export type CustomerCategory = (typeof customerCategories)[number];
